import { render, staticRenderFns } from "./AddEditReadRequestPersonalStaff.vue?vue&type=template&id=78b6ade4&scoped=true"
import script from "./AddEditReadRequestPersonalStaff.vue?vue&type=script&lang=js"
export * from "./AddEditReadRequestPersonalStaff.vue?vue&type=script&lang=js"
import style0 from "./AddEditReadRequestPersonalStaff.vue?vue&type=style&index=0&id=78b6ade4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b6ade4",
  null
  
)

export default component.exports